import React from "react";
import styled from 'styled-components';
import { CHAR_DHAM_DATA } from "../../../../../shared/config/constants";

const ThingsToKeepInMindContainer = styled.div`
    margin-bottom: 18px;
    background-color: #16477f;
    width: 100%;
    height: 340px;
    color: white;
    margin-top: 24px;
    padding-left: 200px;
    padding-right: 200px;
    @media (max-width: 1477px) {
      padding-left: 50px;
      padding-right: 50px;
    }
`;

const ThingsToKeepInMindTitle = styled.p`
    font-size: 24px;
    font-weight: bold;
    padding-top: 32px;
`;

const InstructionsList = styled.ul`
    .instruction {
        padding: 10px;
        font-size: 16px;
        list-style-type: disc;
        margin-left: 30px;
    }
`;

const ThingsToKeepInMind = ({instructionList}) => {
    const instructionsLists = instructionList.map((instruction, index) => (
        <li key={index} className="instruction">
            {instruction}
        </li>
    ));
    return (
      <ThingsToKeepInMindContainer>
        <ThingsToKeepInMindTitle>
          {CHAR_DHAM_DATA.THINGS_KEEP_IN_MIND}
        </ThingsToKeepInMindTitle>
        <InstructionsList>{instructionsLists}</InstructionsList>
      </ThingsToKeepInMindContainer>
    );
}

export default ThingsToKeepInMind;